export { default as Dashboard } from "./dashboard.component";